export const searchOptions = {
  includeMatches: true,
  minMatchCharLength: 3,
  threshold: 0.4,
  keys: [{ name: 'keys.value' }],
};

export const PAGE_SIZE = 10;
